<template>
  <b-row v-if="!filtering" class="my-2 px-2">
    <b-col lg="12">
      <div class="d-flex align-items-center">
        <b-button
          v-if="contagemRegistrosComErro > 0"
          variant="primary-button"
          class="mr-2"
          @click="$emit('reprocessar-todos-erro')"
        >
          <span class="align-middle">Reprocessar Todos com Erro ({{ contagemRegistrosComErro }})</span>
        </b-button>

        <transition name="fade">
          <b-button
            v-if="selectedCount > 0"
            variant="success"
            class="mr-2"
            @click="$emit('reprocessar-selecionados')"
          >
            <span class="align-middle">Reprocessar Selecionados ({{ selectedCount }})</span>
          </b-button>
        </transition>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue';

export default {
  name: 'IntegracaoRndsAcoes',
  components: { BRow, BCol, BButton },
  props: {
    contagemRegistrosComErro: { type: Number, default: 0 },
    selectedCount: { type: Number, default: 0 },
    filtering: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
